import { EmailAlertStoreFactory } from 'common/data/email-alert/store.factory';

import { EmailAlertStoreServiceInterface } from './service.interface';

const emailAlertStore = EmailAlertStoreFactory();

export function EmailAlertStoreService(): EmailAlertStoreServiceInterface {
  return emailAlertStore;
}
